import React, { useCallback, useContext } from 'react'
import { Loader } from '@usap/uicomponents'
import useWmoEnabled from '@usap/carparts/src/shared/hooks/useWmoEnabled'
import { ReturnItemContext } from '../../../Forms/RMAReturnStep/includes'
import Button from '../component/button/DetailButton'
import EstimatedRefund from '../component/EstimatedRefund'
import Header from '../component/Header'
import Instruction from '../component/instruction/Instruction'
import ItemDetail from '../component/itemDetail/ItemDetail'
import { rmaLRPage } from '../constant'
import { LRRefund, ItemDetailsWrapper, Heading2 } from '../style/LifetimeReplacementWmo.css'
import InstructionWmo from '../component/instruction/InstructionWmo'
import ButtonWmo from '../component/button/DetailButtonWmo'


const Detail = ({ moduleData }) => {
  const {
    submitForm,
    orderDetails,
    item,
    setReturnQuantity,
    submitLoading,
  } = { ...moduleData }
  const {
    setSelectedQty,
  } = { ...item }
  const { setReturnQty } = useContext(ReturnItemContext)

  const handleQtyChange = useCallback(quantity => {
    setReturnQuantity(parseInt(quantity, 10))
    setSelectedQty(parseInt(quantity, 10))
    setReturnQty(parseInt(quantity, 10))
  }, [
    setReturnQty,
    setReturnQuantity,
    setSelectedQty,
  ])
  const isWmoEnabled = useWmoEnabled();

  if(isWmoEnabled){
    return (
     <>
        {submitLoading && <Loader />}
        { item && (
          <>
            <Heading2>Submit Lifetime Replacement Claim</Heading2>
            <ItemDetailsWrapper>
                <ItemDetail
                  orderDetails = {orderDetails}
                  item={item}
                  handleQtyChange={handleQtyChange}
                />
                <LRRefund>
                  Estimated Refund:&nbsp;
                  <span>
                    $
                    {parseFloat(item?.itemTotal).toFixed(2)}
                  </span>
                </LRRefund>
                <InstructionWmo type={rmaLRPage.detail} item={item} />
                <ButtonWmo
                  submitForm={submitForm}
                  orderDetails={orderDetails}
                />
            </ItemDetailsWrapper>
          </>
        )}
      </>
    )
  }

  return (
    <>
      {submitLoading && <Loader />}
      <Header
        orderDetails={orderDetails}
        item={item}
      />
      { item && (
        <ItemDetail
          item={item}
          handleQtyChange={handleQtyChange}
        />
      )}
      <EstimatedRefund item={item} />
      <Instruction type={rmaLRPage.detail} item={item} />
      <Button
        submitForm={submitForm}
        orderDetails={orderDetails}
      />
    </>
  )
}

export default Detail
